import React from "react";
import { useNavigate } from "react-router-dom";

function BackArrowIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="dashboard-detail-back-icon"
      aria-hidden="true"
    >
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export default function DashboardBackButton({
  to = "/dashboard",
  label = "Back to Dashboard",
  className = "",
}) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className={`dashboard-detail-back-btn${className ? ` ${className}` : ""}`}
      aria-label={label}
      title={label}
    >
      <BackArrowIcon />
      <span className="dashboard-detail-back-tooltip">{label}</span>
    </button>
  );
}
